import { ProductHydrationErrors } from "./hydrationErrors";

export type RTPMappingProduct = {
  product: string;
  season: string;
  fulfillmentSeason?: string;
  ageBin: string;
  productHeaderCode: string | null;
  accessRule: string | null;
  mediaProductHeaderCode: string | null;
  id: string;
  isResortConfigurable: boolean;
  isError: boolean | null;
  errorDescription: string;
  entitlementTypeId?: string;
  fulfillmentSeasonId?: string;
  hydrationErrors?: ProductHydrationErrors;
}

export type SiriuswareMappingProduct = {
  product: string;
  season: string;
  ageBin: string;
  fulfillmentSeason?: string;
  department: string;
  category: string;
  item: string;
  productType: string;
  wtpReload: boolean;
  id: string;
  isResortConfigurable: boolean;
  isError: boolean | null;
  errorDescription: string;
  entitlementTypeId?: string;
  fulfillmentSeasonId?: string;
  hydrationErrors?: ProductHydrationErrors;
}

export type ResortMappingObject = {
  posProvider: string;
  productMappings: SiriuswareMappingProduct[] | RTPMappingProduct[];
  hasError: boolean;
}

export const defaultResortMappingObject: ResortMappingObject = {
  posProvider: 'string',
    productMappings: [],
    hasError: false
}
